// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._104h3wqs-7i56cV47Xh862 {\n\n}\n\n._22D4GYHMvC51ffSudkfLBS {\n    text-align: right;\n}\n\n._2svsjrfHCFyNnjDUEGvJ2F {\n    cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"special": "_104h3wqs-7i56cV47Xh862",
	"controls": "_22D4GYHMvC51ffSudkfLBS",
	"close": "_2svsjrfHCFyNnjDUEGvJ2F"
};
module.exports = exports;
